import { render } from "./BandejaPedidos.vue?vue&type=template&id=75aaeed0"
import script from "./BandejaPedidos.vue?vue&type=script&lang=js"
export * from "./BandejaPedidos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__